import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const addToCart = createAsyncThunk("/cart/add-to-cart", async (obj) => {
  const response = await fetch(`${process.env.REACT_APP_PUBLIC_URL}calc`, {
    method: "POST",
    body: JSON.stringify(obj),
    headers: {
      "Content-Type": "application/json",
    },
  });
  return await response.json();
});

export const cartSlice = createSlice({
  name: "cart",
  initialState: {
    loading: "idle",
    data: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(addToCart.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(addToCart.rejected, (state) => {
        state.loading = "rejected";
      })
      .addCase(addToCart.fulfilled, (state, action) => {
        if (!("redirect_url" in action.payload)) {
          state.loading = "resolved";
          state.data = action.payload;
        }
      });
  },
});
